"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { supportCta as data } from "@/lib/data/support";

const accent = "var(--color-cyan)";

export function SupportCta() {
  return (
    <Section id="cta" className="relative">
      <Container>
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl glass p-10 sm:p-14 text-center" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 25%, transparent), 0 0 80px -20px color-mix(in oklch, ${accent} 50%, transparent)` }}>
            <div className="pointer-events-none absolute -top-1/2 -right-1/4 h-[120%] w-[60%] rounded-full opacity-30 blur-[100px]" style={{ background: accent }} />
            <div className="relative">
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.eyebrow}</span>
              <h2 className="mt-4 max-w-3xl mx-auto">{data.title}</h2>
              <p className="mt-5 max-w-2xl mx-auto text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
              <p className="mt-3 max-w-2xl mx-auto text-body-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.body}</p>
              <div className="mt-8 grid sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
                <div className="glass rounded-2xl p-5 text-left" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
                  <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Support Access</span>
                  <ul className="mt-3 space-y-1.5">
                    {data.support.map((s, i) => (
                      <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{s}</li>
                    ))}
                  </ul>
                </div>
                <div className="glass rounded-2xl p-5 text-left" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
                  <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Next Steps</span>
                  <ul className="mt-3 space-y-1.5">
                    {data.nextSteps.map((s, i) => (
                      <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{s}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                {data.cta.map((c, i) => (
                  <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-12 px-7 inline-flex items-center gap-2 rounded-full font-semibold text-base shadow-2xl" : "btn-glass h-12 px-7 inline-flex items-center gap-2 rounded-full font-semibold text-base"}>
                    {c.label} <ArrowRight className="h-4 w-4" />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
